import React, { useMemo, type FC } from 'react'

import { useIntl } from 'react-intl'

import { Select } from 'mailup-web-components'

import { changeCriterionCallback } from 'Pages/RecipientsList/recoil/callbacks/filters'
import { anagraphicFieldMatchOperatorState } from 'Pages/RecipientsList/recoil/state/filters'
import { useRecoilCallback, useRecoilValue } from 'recoil'

interface InputTextMatchOperatorProps {
  index: number
}

const InputTextMatchOperator: FC<InputTextMatchOperatorProps> = ({ index }) => {
  const intl = useIntl()

  const matchOperator = useRecoilValue(anagraphicFieldMatchOperatorState(index))

  const changeCriterion = useRecoilCallback(changeCriterionCallback, [])

  const options = useMemo(() => {
    return [
      {
        value: 'TextPrefix',
        label: intl.formatMessage({ id: 'Load.RecipientsList.TextPrefix' }),
      },
      {
        value: 'TextNotPrefix',
        label: intl.formatMessage({ id: 'Load.RecipientsList.TextNotPrefix' }),
      },
      {
        value: 'TextSuffix',
        label: intl.formatMessage({ id: 'Load.RecipientsList.TextSuffix' }),
      },
      {
        value: 'TextNotSuffix',
        label: intl.formatMessage({ id: 'Load.RecipientsList.TextNotSuffix' }),
      },
      {
        value: 'TextSame',
        label: intl.formatMessage({ id: 'Load.RecipientsList.TextSame' }),
      },
      {
        value: 'TextDifferent',
        label: intl.formatMessage({ id: 'Load.RecipientsList.TextDifferent' }),
      },

      {
        value: 'TextContains',
        label: intl.formatMessage({ id: 'Load.RecipientsList.TextContains' }),
      },
      {
        value: 'TextNotContains',
        label: intl.formatMessage({
          id: 'Load.RecipientsList.TextNotContains',
        }),
      },
      {
        value: 'TextNotNullNotEmpty',
        label: intl.formatMessage({
          id: 'Load.RecipientsList.TextNotNullNotEmpty',
        }),
      },
      {
        value: 'TextNullEmpty',
        label: intl.formatMessage({ id: 'Load.RecipientsList.TextNullEmpty' }),
      },
      {
        value: 'TextIn',
        label: intl.formatMessage({ id: 'Load.RecipientsList.TextIn' }),
      },
      {
        value: 'TextNotIn',
        label: intl.formatMessage({ id: 'Load.RecipientsList.TextNotIn' }),
      },
      {
        value: 'TextGreater',
        label: intl.formatMessage({ id: 'Load.RecipientsList.TextGreater' }),
      },
      {
        value: 'TextGreaterEqual',
        label: intl.formatMessage({
          id: 'Load.RecipientsList.TextGreaterEqual',
        }),
      },

      {
        value: 'TextLess',
        label: intl.formatMessage({ id: 'Load.RecipientsList.TextLess' }),
      },
      {
        value: 'TextLessEqual',
        label: intl.formatMessage({ id: 'Load.RecipientsList.TextLessEqual' }),
      },
    ]
  }, [intl])

  const handleChange = (v: string): void => {
    void changeCriterion('matchOperator', v, index)
  }

  return (
    <Select
      value={matchOperator}
      options={options}
      placeholder={intl.formatMessage({
        id: 'Load.RecipientsList.SelectMatchOperatorPlaceholder',
      })}
      onChange={handleChange}
    />
  )
}

export default InputTextMatchOperator
